import { PATH_DASHBOARD } from "routes/path";
import SvgIconStyle from "components/svg-icon/SvgIconStyle";

const getIcon = (name) => (
  <SvgIconStyle
    src={`/assets/images/sidebar-icons/${name}.svg`}
    sx={{ width: "100%", height: "100%" }}
  />
);

export const ICONS = {
  root: getIcon("root"),
  balances: getIcon("balances"),
  payments: getIcon("payments"),
  invoices: getIcon("invoices"),
  cryptoSettings: getIcon("cryptoSettings"),
  settings: getIcon("settings"),
};

const sidebarConfig = (role = "") => {
  console.log(role);
  const sidebarMenu = [
    /* PLOP_COMPONENTS_PAGE_IMPORT */
    {
      title: "WhiteList",
      path: PATH_DASHBOARD.Whitelist,
      icon: ICONS.cryptoSettings,
      roles: ["admin", "superadmin", "customer-support"],
    },
    {
      title: "Registration",
      path: PATH_DASHBOARD.RegisterEmail,
      icon: ICONS.cryptoSettings,
      roles: ["admin", "superadmin", "customer-support"],
    },
    {
      title: "Merchants",
      path: PATH_DASHBOARD.Merchants,
      icon: ICONS.cryptoSettings,
      roles: ["admin", "superadmin", "customer-support"],
    },
    {
      title: "Charges",
      path: PATH_DASHBOARD.Charges,
      icon: ICONS.cryptoSettings,
      roles: ["admin", "superadmin", "customer-support"],
    },

    {
      title: "Payments",
      path: "payment",
      icon: ICONS.cryptoSettings,
      roles: ["admin", "superadmin", "customer-support"],
      children: [
        {
          title: "Unmatched Payment",
          path: PATH_DASHBOARD.UnmatchedPayment,
          icon: ICONS.cryptoSettings,
          roles: ["admin", "superadmin", "customer-support"],
        },
        {
          title: "Matched Payments",
          path: PATH_DASHBOARD.Payments,
          icon: ICONS.cryptoSettings,
          roles: ["admin", "superadmin", "customer-support"],
        },
      ],
    },
    {
      title: "Merchants withdrawals",
      path: PATH_DASHBOARD.WithdrawalHistory,
      icon: ICONS.cryptoSettings,
      roles: ["admin", "superadmin", "customer-support"],
    },
    {
      title: "System Balances",
      path: "system",
      icon: ICONS.cryptoSettings,
      roles: ["admin", "superadmin", "customer-support"],
      children: [
        {
          title: "System Balances Management",
          path: PATH_DASHBOARD.SystemBalances,
          icon: ICONS.cryptoSettings,
          roles: ["admin", "superadmin", "customer-support"],
        },

        {
          title: "System Withdraw History Log",
          path: PATH_DASHBOARD.SystemWithdrawHistoryLog,
          icon: ICONS.cryptoSettings,
          roles: ["admin", "superadmin", "customer-support"],
        },
      ],
    },

    {
      title: "Settings",
      path: "settings",
      icon: ICONS.cryptoSettings,
      roles: ["admin", "superadmin", "customer-support"],
      children: [
        {
          title: "General settings",
          path: PATH_DASHBOARD.Setting,
          icon: ICONS.cryptoSettings,
          roles: ["admin", "superadmin", "customer-support"],
        },
        {
          title: "Crypto Currencies",
          path: PATH_DASHBOARD.CryptoCurrency,
          icon: ICONS.cryptoSettings,
          roles: ["admin", "superadmin", "customer-support"],
        },

        {
          title: "Blockchain Network",
          path: PATH_DASHBOARD.Chains,
          icon: ICONS.cryptoSettings,
          roles: ["admin", "superadmin", "customer-support"],
        },
      ],
    },

    {
      title: "Operating Wallets",
      path: "/dashboard/operating-wallet",
      icon: ICONS.cryptoSettings,
      roles: ["admin", "superadmin"],
      children: [
        {
          title: "Operating Wallet Management",
          path: PATH_DASHBOARD.OperationWalletManagement,
          icon: ICONS.cryptoSettings,
          roles: ["admin", "superadmin"],
        },
        {
          title: "Operating wallet history log",
          path: "/dashboard/operating-wallet-history-log",
          icon: ICONS.settings,
          roles: ["admin", "superadmin", "customer-support"],
          children: [
            {
              path: PATH_DASHBOARD.tokentransactions,
              title: "Token IN/OUT",
            },
            {
              path: PATH_DASHBOARD.operatingactions,
              title: "Operating actions",
            },

            {
              path: PATH_DASHBOARD.owHistoryLog,
              title: "Operating Wallet History",
            },
          ],
        },
      ],
    },

    {
      title: "Admin Management",
      path: PATH_DASHBOARD.AdminManagement,
      icon: ICONS.cryptoSettings,
      roles: ["superadmin"],
    },
  ];

  const rolesMenu = sidebarMenu.filter((menu) => {
    return menu.roles.includes(role);
  });
  return [
    {
      subheader: " ",
      items: rolesMenu,
    },
  ];
};

export default sidebarConfig;
